<template>
  <div v-if="loading" class="row" style="background-color: #fff;">
    <div class="col-12">
      <div class="loader">
        <!-- <b-spinner
          variant="primary"
          type="grow"
          :label="`${$t('reports.detractor.loadingLabel')}...`"
        ></b-spinner> -->
        <idx-skeleton-chart type="pizza" />
      </div>
    </div>
  </div>
  <div v-else class="row">
    <div class="col-12">
      <div class="reports-wrapper" style="margin-top: 16px;">
        <div class="card" style="width: 100%;">
          <highcharts :options="chartOptionsPie"></highcharts>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RadialProgressBar from 'vue-radial-progress';
import idxSkeletonChart from '@/components/molecules/idx-skeleton-chart';
import Indicators from '../../reports/indicators';
import EventBus from '../../../../../eventBus';
import api from '../../../../../services/api';

export default {
  name: 'ChartSentimentRating',

  components: {
    RadialProgressBar,
    Indicators,
    idxSkeletonChart,
  },

  props: ['dataGraph'],

  data: () => ({
    loading: true,
    chartOptionsPie: {
      title: {
        text: '',
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: true,
            format: '<b>{point.name}</b>: {point.percentage:.1f}%',
          },
          showInLegend: true,
        },
      },
      colors: ['#22CD70', '#F3C102', '#E84C3E'],
      series: [
        {
          innerSize: '50%',
          name: 'Quantidade',
          data: [
            {
              name: 'Positivo',
              y: 0,
            },
            {
              name: 'Neutro',
              y: 0,
            },
            {
              name: 'Negativo',
              y: 0,
            },
          ],
        },
      ],
      chart: {
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'pie',
      },
    },
    chartOptions: {
      title: {
        align: 'left',
        text: '',
        style: {
          color: '#5f6368',
        },
      },
      chart: {
        type: 'spline',
        borderColor: 'rgba(0, 0, 0, 0.09)',
      },
      xAxis: {
        categories: [],
        visible: true,
        labels: {},
      },
      yAxis: {
        title: {
          text: '',
        },
        stackLabels: {
          enabled: true,
          fontWeight: 'bold',
        },
      },
      series: [
        {
          name: 'Score',
          data: [],
        },
      ],
      legend: {
        enabled: false,
      },
      plotOptions: {
        spline: {
          lineWidth: 3,
        },
        column: {
          pointPadding: 0.1,
          borderWidth: 0,
          dataLabels: {
            enabled: true,
          },
        },
        line: {
          dataLabels: {
            enabled: true,
          },
        },
        area: {
          dataLabels: {
            enabled: true,
          },
        },
        series: {
          groupPadding: 0,
          pointPadding: 0.05,
          borderWidth: 0,
        },
      },
      colors: ['#4ce595'],
    },
  }),

  methods: {
    async getSentmentAnalysisInfo(data) {
      this.loading = true;

      const response = await api.get('/reports/sentiment-analysis-panel', {
        headers: {
          'x-access-token': this.userAuth.token,
        },
        params: {
          actionId: data.actionId ? data.actionId._id : null,
          ih1: data.ih1 && data.ih1.length > 0 ? data.ih1.map((item) => item._id): null,
          period: data.period,
          metric: data.metric ? data.metric : null,
          groupId: data.actionGroupId ? data.actionGroupId._id : null,
          indicator: data.indicator ? data.indicator : null,
          indicatorValue: data.valueIndicator ? data.valueIndicator : null,
          // indicatorRange: this.indicatorData.range,
          _id: this.dataGraph._id,
        },
      });

      this.chartOptionsPie.series[0].data[0].y = response.data.qty.positive;
      this.chartOptionsPie.series[0].data[1].y = response.data.qty.neutral;
      this.chartOptionsPie.series[0].data[2].y = response.data.qty.negative;

      this.chartOptionsPie.chart.height =
        this.dataGraph && `${this.dataGraph.layout.h * 35}px`;

      this.loading = false;
    },

    setColor(score) {
      if (score >= 60) {
        return '#22CD70';
      } else if (score >= 0) {
        return '#F3C102';
      }

      return '#E84C3E';
    },
  },

  async created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
    await this.getSentmentAnalysisInfo(this.dataGraph);

    EventBus.$on('update-chart-sentiment-rating', (items) => {
      this.getSentmentAnalysisInfo(items);
    });
  },
};
</script>

<style scoped lang="scss">
.loader {
  width: 100%;
  height: 350px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.reports-wrapper {
  width: 100%;
  display: flex;
  overflow: hidden;
  flex-direction: row;
  justify-content: space-between;
}

.card {
  background-color: #fff;
  padding: 16px;
  border-color: #fff;

  h1 {
    font-size: 22px;
  }

  .sentiment-area {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-around;
  }
}

.page-spacing {
  padding-left: 15px;
  padding-right: 15px;
}

.graphic-card {
  display: flex;
  flex-direction: column;
  padding: 15px 35px;
  border: 1px solid #eee;
  height: 100%;
}

.chart-area {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.text-color {
  color: #5f6368;
  font-size: 18px;
  fill: #5f6368;
}

.highcharts-background-pie {
  width: 0;
}

.numbers-area {
  max-width: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/highcharts/sentment-analysis/panels/chart-sentiment-rating.vue